const config = {
  // version: '1.0.0',
  // copyrightYear: () => { return Date().getFullYear() },
  gatsby: {
    pathPrefix: 'docs/',
    siteUrl: 'https://takemebot.com/docs/',
    gaTrackingId: null,
    trailingSlash: false,
  },
  header: {
    logo: 'https://takemebot.com/app/assets/images/mebot-logo.webp',
    logoLink: 'https://takemebot.com/docs/',
    title: "",
    githubUrl: '',
    helpUrl: '',
    tweetText: '',
    social: ``,
    links: [{ text: '', link: '' }],
    search: {
      enabled: true,
      indexName: 'mebot',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
    },
  },
  sidebar: {
    forcedNavOrder: [

      '/browser_events', // add trailing slash if enabled above
      '/desktop_action_events',
      '/ocr',
      '/inputs_outputs',
      '/control_structure_events',
      '/generative_ai',
      '/wait_events',
      '/mail_events',
      '/bot',
      '/utils_events',
      '/templates_event',

    ],
    collapsedNav: [
      // add trailing slash if enabled above
    ],
    links: [{ text: 'Mebot', link: 'https://takemebot.com' }],
    frontLine: false,
    ignoreIndex: true,
    title:
      "",
  },
  siteMetadata: {
    title: 'Mebot RPA Platform',
    description: 'Documentation for mebot RPA platform ',
    ogImage: null,
    docsLocation: '',
    favicon: 'https://takemebot.com/favicon-32x32.png',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'Mebot Documentation',
      short_name: 'Mebot Documentation',
      start_url: '/',
      background_color: '#FEA403',
      theme_color: '#efefef',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
